/* QOWAA FIT — Wishlist (liste d'envies)
   100 % localStorage (clé qowaa_wishlist) : [{handle,title,price,image,url,variant,addedAt}].
   ⚠️ Local à l'appareil : pas de sync metafield client (= app/Customer Account API, hors thème pur).
   - Bouton cœur réutilisable [data-wishlist-toggle] (cards + PDP) : toggle + état + animation.
   - Compteur header [data-wishlist-count]. Page [data-wishlist-page] : rendu + retrait + tout au panier.
   - ARIA live + GA4 (wishlist_add / wishlist_remove / wishlist_page_view / wishlist_add_all_to_cart). */
(function () {
  'use strict';
  var KEY = 'qowaa_wishlist';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    broadcast();
  }
  function has(handle) { return read().some(function (p) { return p && p.handle === handle; }); }

  function dl(event, handle) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: event, product_handle: handle || '' });
    }
  }

  // ── Région d'annonce ARIA ────────────────────────────────
  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.setAttribute('aria-live', 'polite');
      live.className = 'wl-sr-only';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }

  // ── Toggle ───────────────────────────────────────────────
  function toggle(btn) {
    var handle = btn.getAttribute('data-wl-handle');
    if (!handle) return;
    var list = read();
    var idx = -1;
    list.forEach(function (p, i) { if (p && p.handle === handle) idx = i; });

    if (idx > -1) {
      list.splice(idx, 1);
      write(list);
      setState(btn, false);
      announce('Retiré de tes envies.');
      dl('wishlist_remove', handle);
    } else {
      list.unshift({
        handle: handle,
        title: btn.getAttribute('data-wl-title') || '',
        price: btn.getAttribute('data-wl-price') || '',
        image: btn.getAttribute('data-wl-image') || '',
        url: btn.getAttribute('data-wl-url') || '',
        variant: btn.getAttribute('data-wl-variant') || '',
        addedAt: Date.now()
      });
      write(list);
      setState(btn, true);
      btn.classList.add('is-anim');
      setTimeout(function () { btn.classList.remove('is-anim'); }, 240);
      announce('Ajouté à tes envies.');
      dl('wishlist_add', handle);
    }
  }

  function setState(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('[data-wl-label]');
    if (label) label.textContent = saved ? 'Sauvegardé' : 'Sauvegarder';
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      setState(btn, has(btn.getAttribute('data-wl-handle')));
    });
  }

  // ── Compteur header ──────────────────────────────────────
  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function broadcast() { updateCount(); renderPage(); }

  // ── Page wishlist ────────────────────────────────────────
  function escAttr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

  function renderPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-wl-grid]');
    var empty = page.querySelector('[data-wl-empty]');
    var countEl = page.querySelector('[data-wl-page-count]');
    var actions = page.querySelector('[data-wl-actions]');
    var items = read();

    if (countEl) countEl.textContent = items.length;

    if (!items.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (actions) actions.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (actions) actions.hidden = false;
    if (!grid) return;

    var frag = document.createDocumentFragment();
    items.forEach(function (p) {
      var card = document.createElement('article');
      card.className = 'wl-card';
      card.innerHTML =
        '<a class="wl-card__media" href="' + escAttr(p.url) + '">' +
          (p.image ? '<img src="' + escAttr(p.image) + '" alt="" loading="lazy" width="600" height="750">' : '') +
        '</a>' +
        '<button type="button" class="wl-card__remove" data-wl-remove="' + escAttr(p.handle) + '" aria-label="Retirer de mes envies">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<a class="wl-card__title" href="' + escAttr(p.url) + '"></a>' +
        '<span class="wl-card__price"></span>';
      card.querySelector('.wl-card__title').textContent = p.title || '';
      card.querySelector('.wl-card__price').textContent = p.price || '';
      frag.appendChild(card);
    });
    grid.innerHTML = '';
    grid.appendChild(frag);
  }

  function addAllToCart(btn) {
    var items = read().filter(function (p) { return p && p.variant; });
    if (!items.length) return;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(function (p) { return { id: Number(p.variant), quantity: 1 }; }) })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        dl('wishlist_add_all_to_cart', '');
        if (res.ok) { window.location.href = '/cart'; }
        else { announce("Certaines pièces ne sont plus disponibles."); }
      })
      .catch(function () { announce("Impossible d'ajouter au panier pour l'instant."); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }

  // ── Délégation des clics ─────────────────────────────────
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) { e.preventDefault(); toggle(toggleBtn); return; }

    var removeBtn = e.target.closest('[data-wl-remove]');
    if (removeBtn) {
      var handle = removeBtn.getAttribute('data-wl-remove');
      write(read().filter(function (p) { return p && p.handle !== handle; }));
      syncButtons();
      announce('Retiré de tes envies.');
      dl('wishlist_remove', handle);
      return;
    }

    var addAll = e.target.closest('[data-wl-add-all]');
    if (addAll) { e.preventDefault(); addAllToCart(addAll); return; }
  });

  // Sync entre onglets
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncButtons(); broadcast(); } });

  function boot() {
    syncButtons();
    updateCount();
    if (document.querySelector('[data-wishlist-page]')) { renderPage(); dl('wishlist_page_view', ''); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { syncButtons(); updateCount(); renderPage(); });
})();
